import React, {useEffect, useRef} from "react";

function FilmGallery(props) {
    const inputRef = useRef()
    const [parallax, setParallax] = React.useState(100);

    useEffect(()=> {
        const offset = window.innerHeight;
        const LIMIT = 400;

        const calculateParallax = () => {
            if (!inputRef.current) return;
            const startMark = inputRef.current.offsetTop - offset;
            const winScroll = document.body.scrollTop || document.documentElement.scrollTop;
            const parallaxVal = ((((winScroll-startMark)/LIMIT)*props.listOfImages.length))%props.listOfImages.length;
            setParallax(Math.floor(parallaxVal));
        };

        calculateParallax();

        window.addEventListener("scroll", calculateParallax);
        return () => {
            window.removeEventListener("scroll", calculateParallax);
        };
    },[props.listOfImages]);

    return (
        <div
            ref={inputRef}
            className={'film-gallery'}
            style={{
                backgroundImage: `url('${props.listOfImages[parallax]}')`
            }}
        >
        </div>
    )
}

export default FilmGallery;